export function indexArrToWbs(indexArr: number[]) {
  return indexArr.map((index) => index + 1).join('.');
}
